import { Checkbox } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { connect } from "react-redux";

import { isTagEntry } from "./cellUtils";
import {CustomGridColDef} from "../gridColumnDefs";

export interface BooleanCellColDef extends CustomGridColDef
{
    addTag: (state: string, type: string, value: boolean) => void
    setTag: (state: string, tag: string, value: boolean) => void
}

function BooleanConstantCell({ colDef, field, row, value }: GridRenderCellParams)
{
    const { setTag } = colDef as unknown as BooleanCellColDef;

    if (isTagEntry(value)) {
        const firstTag = value.tags[0];
        const checked = firstTag.value;
        const handleClick = () =>
            firstTag.id ? setTag(row.id, firstTag.id, ! checked) : console.error("Unknown id for tag");

        return <Checkbox checked={Boolean(checked)} onClick={handleClick}/>
    } else {
        return null;
    }
}

const mapStateToProps = (store: never) => ({
});
export default connect(mapStateToProps, {
})(BooleanConstantCell);